<template>
  <div>
    <div class="file-upload-form">
      <input @change="selectedFile" type="file" class="btn btn-white" >
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        uploadFile: null
      }
    },
    methods: {
      selectedFile: function (e) {
        e.preventDefault()
        let files = e.target.files
        var file = files[0]
        this.$emit('input', file)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FIleUpload.vue?281e9434